module.exports = __webpack_public_path__ + "img/客户.073e940f.png";